import { computed, inject, Injectable, Signal } from '@angular/core';
import { ReadonlyRepositoryObjectService, Result } from '@softline/core';
import { LagerlistenVerbrauchState } from '../data/verbrauch';
import { LagerlistenVerbrauchRepository } from '../repositories/lagerlisten-verbrauch.repository';
import { QueryService, RohstoffbereitstellungQuery } from './query.service';

@Injectable()
export class LagerlistenVerbrauchService extends ReadonlyRepositoryObjectService<
  LagerlistenVerbrauchState | null,
  Result<LagerlistenVerbrauchState>,
  RohstoffbereitstellungQuery | undefined
> {
  readonly #queryService = inject(QueryService);

  override params: Signal<RohstoffbereitstellungQuery | undefined> = computed(() => {
    const query = this.#queryService.query();
    if (!query) return undefined;
    return query;
  });

  constructor() {
    super(inject(LagerlistenVerbrauchRepository));
  }

  protected override getValue(
    result: Result<LagerlistenVerbrauchState> | null | undefined
  ): LagerlistenVerbrauchState | null {
    return result?.result ?? null;
  }
}
